import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { FormControl, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { useState } from "react";
import Swal from "sweetalert2";
import { ToastContainer } from "react-toastify";
import PropTypes from "prop-types";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AdminVegetableTypeDetail({ open, handleClose, id, clear }) {
  // Local State
  const [formData, setFormData] = useState({
    typeName: "",
  });
  const [fetch, setFetch] = useState(true);

  // Redux State
  const data = useSelector((state) => state.vegetableType.data.docs);

  useEffect(() => {
    if (fetch) {
      let x = data.findIndex((item) => item._id === id);
      if (x > -1) {
          setFormData({
              typeName : data[x].typeName ? data[x].typeName : ""
          })
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan mohon refresh halaman / kontak developer anda",
        });
      }
      setFetch(false)
    }
  }, [fetch]);

  const handleCloseModal = () => {
    handleClose();
    clear();
  }

  return (
    <>
      <ToastContainer />
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseModal}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"DETAIL DATA TIPE SAYURAN"}</DialogTitle>
        <form >
          <DialogContent style={{ padding: "5px 24px" }}>
            <FormControl>
              <TextField
                InputLabelProps={{ shrink: true }}
                required
                inputProps={{ maxLength: 15, readOnly: true }}
                size="small"
                error={false}
                label="NAMA TIPE SAYURAN"
                value={formData.typeName}
                name="typeName"
                fullWidth
                variant="standard"
                style={{ width: "90vw", maxWidth: "400px" }}
              />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal} color="error">
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

AdminVegetableTypeDetail.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  clear: PropTypes.func,
  id: PropTypes.string
};
